import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';


const Metrics = Loadable({
    loader: () => import('./components/log-metrics'),
    loading: Loading,
  });


export const routes = [
    {
      path: '/metrics',
      exact: true,
      name: 'metrics',
      component: Metrics,
    },
  ];
  